import styled from 'styled-components';

const styledSchedule = (Component) => styled(Component)`
  .fields {
    padding-top: 3px;
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
  }
`;

export default styledSchedule;
